<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2023-09-07 14:02:39
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2023-09-07 17:22:00
 * @FilePath: \front\src\views\System\sms\smsSend.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="about">
          <div class="pg-header">
              <div>
                  <label class="title">充值记录</label>
              </div>
              <div class="algr">
                  <div class="pg-nav">
                      <i class="icon-home"></i>
                      <span>系统管理</span>|
                      <span>短信用量查询</span>|
                      <span class="active">充值记录</span>
                  </div>
              </div>
          </div>
          <CountTitle :data="this.count"/>
          <div class="collapse-wrap">
              <div class="table-wrap">
                  <el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading">
                      <el-table-column prop="initialTime" label="充值日期"></el-table-column>
                      <el-table-column prop="messageNumber" label="购买短信条数" ></el-table-column>
                  </el-table>	
                  <div class="pagination">
                      <el-row>
                          <el-col :span="12">
                              <div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
                              <div class="record">总计<span v-text="list.total"></span>条记录</div>
                          </el-col>
                          <el-col :span="12" style="text-align: right;">
                              <el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
                          </el-col>
                      </el-row>
                  </div>
              </div>				
          </div>
    </div>
  </template>
  
  <script>
  import api from '@/service/api.js';
  import mixin from '@/views/mixin';
  import dayjs from 'dayjs';
  import CountTitle from '../components/countTitle.vue';
  export default {
    components:{CountTitle},
      data(){
          return {
            filter:{
                pageNumber: 1,
				pageSize: 20
            },
            list: {
                current: 1,
                total: 0,
                pageSize: 0,
                data: null,
                pageNumber: 1,
            },
            count:{},
            isLoading:false
          }
      },
      created() {
          this.loadList();	
      },
      methods: {
          async loadList() {
              this.isLoading = true;
              let res = await api.getSmsCountList(this.filter);
              if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
              console.log(res)
              this.list.total = +res.data.pageInfo.total;
              this.list.current = this.filter.pageNumber;
              this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
              console.log(this.list,'========ll');
              this.list.data = res.data.pageInfo.list;
              this.count=res.data;
              this.isLoading = false;
          },
                  // 过滤条件 更改
                  handleFilter(key, val) {
                      switch(key) {
                          case 0:
                              if (this.filter.date) {
                                  this.filter.sendTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
                                  this.filter.sendTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
                              } else {
                                  this.filter.sendTimeStart = '';
                                  this.filter.sendTimeEnd = '';						
                              }
                              break;
                      }
                      this.filter.pageNumber = 1;
                      this.loadList();
                  },			
                  handleSizeChange(v) {
                      this.filter.pageSize = v;
                      this.filter.pageNumber = 1;
                      this.loadList();
                  },
                  handleCurrentChange(v) {
                      this.filter.pageNumber = v;
                      this.loadList();
                  },
              }
          }
          </script>
          
          <style lang="less" scoped>
          @import '@/assets/style/var';
              /deep/.search-bar .el-select .el-input{
                  width: 140px
              }
              /deep/.el-form .el-input{
                  width: 180px
              }	
          </style>
          
  